import { combineReducers } from 'redux'

import basketSlice from './Basket/reducer'
import formsReducer from './Forms/reducer'
import loaderSlice from './Loader/LoaderPopup/reducer'
import cinemaSelectSlice from './Modal/CinemaSelectWindow/reducer'
import documentSlice from './Modal/DocumentPopupWindow/reducer'
import windowMessageSlice from './Windows/CentralMessagesList/reducer'

export default combineReducers({
    basket: basketSlice,
    forms: formsReducer,
    windowMessage: windowMessageSlice,
    mainLoader: loaderSlice,
    document: documentSlice,
    cinemaSelect: cinemaSelectSlice,
})
